import React from "react";
import { RCCBadge, RCCButton, RCCGrid, RCCPopover } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import IComponentBadge from "react-common-components/dist/components/Badge/interface";

export interface IBadgeTraceabilityBasic{
	color?: IComponentBadge["color"];
	textBadge?: string;
	layout: "card" | "modal";
    traceability: {
        [key: string]: string;
    }
}

const BadgeTraceabilityBasic: React.FC<IBadgeTraceabilityBasic> = ({
	color,
	textBadge,
	layout,
	traceability
}) => {
	const { translate } = useTranslation();

	return(
		<>
			<RCCGrid item>
				<RCCPopover
					color="grey"
					header={{
						title:translate("Rastreabilidade")
					}}
					position={layout === "card" ? "bottom" : "leftEnd"}
					body={{
						custom: (
							<>
								{Object.keys(traceability).map((keys: string, index: number) => {
									if(keys !== "Link" && keys !== "RastreabilidadeId"){
										return (<RCCGrid key={keys} container item>
											<span style={{textAlign: "left", padding: "2px"}}><strong>{translate(keys)}:</strong> {index === 0 ? translate(`actionTraceabilityWorkspace:${traceability[keys]}`) : traceability[keys]}</span>
										</RCCGrid>);
									}

									return "";
								})}
							</>
						)
					}}
				>
					{
						layout === "modal" && 
						<RCCButton color={color || "grey"} onClick={() => window.open(traceability.Link)}>
							<span title={translate("Clique para abrir a rastreabilidade")}>{translate(`actionTraceabilityWorkspace:${traceability.Origem}`)}</span>
						</RCCButton>
					}
					{
						layout === "card" &&
						<RCCBadge color={color || "grey"} onClick={() => window.open(traceability.Link)} styleInline="padding: 2px 8px; font-size: 0.78rem;" >
							<span title={translate("Clique para abrir a rastreabilidade")}>{textBadge}</span>
						</RCCBadge>
					}
				</RCCPopover>
			</RCCGrid>
		</>
	);
};

export default BadgeTraceabilityBasic;
